import React, { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "../auth/hooks/useAuth";
import { AssignmentsContainer } from "./styled_components/containers";
import War from "./components/war";
import Practice from "../games/components/Show/Practice";
import Learn from "../games/components/Show/Learn";
import NumInt from "../games/applications/NumeracyIntervention/Rating"
import MTC from "../games/applications/MTC/Practice"
import Assessment from "../games/applications/MathsAssessments/Basic"
import useWar from "./components/useWar";
import { Scale } from 'react-scaling';
import { Router, navigate } from "@reach/router";

import { LinkButton } from "../../globals/components/button";
import { Link } from "@reach/router";

import CupBG from "../games/assets/placeholder_screen.png";
import sCupBG from "../games/assets/spatsbg.png";
import mCupBG from "../games/assets/cup_bg.png";
import ks1CupBG from "../games/assets/ks1cupbg.png";

import Rating from "../../modules/games/components/Show/Rating"

import MTCRating from "../games/applications/MTC/Rating"
import SPATS from "../games/components/Show/SpellingSATsPractice";
import KS1 from "../games/components/Show/KS1Practice";

//import useUsername from "../games/hooks/useUsername";

import styled from "styled-components";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@material-ui/core";

var myWarScore = null;

function Assignments(props) {
    const { state } = useAuth();
    const { access_token } = state;
    const [assignments, updateAssignments] = useState(null);
    const [doingAssignment, updateDoingAssignment] = useState(null);
    const [clashLeaderboard, setClashLeaderboard] = useState(null);
    const [clashRecent, setClashRecent] = useState(null);
    const [refresher, setRefresher] = useState(false);
    const [gameStatus, setGameStatus] = useState(true);
    const war = useWar();

    const [doingMTC, setDoingMTC] = useState(false);
    const [doingSPATS, setDoingSPATS] = useState(false);
    const [doingKS1, setDoingKS1] = useState(false);

    // Info Popup State
    const [infoOpen, setInfoOpen] = useState(false);

    const handleInfoOpen = () => setInfoOpen(true);
    const handleInfoClose = () => setInfoOpen(false);

    console.log(war);

    //var details;
    //details = useUsername();
    //console.log(details);

    function DoMTC() {
        console.log("SET DO MTC");
        setDoingMTC(true);
    }

    function DoSpellingSATs() {
        console.log("SET DO SPATS");
        setDoingSPATS(true);
    }

    function DoKS1() {
        console.log("SET DO KS1");
        setDoingKS1(true);
    }

    var game = {
        id: 23,
        game_type: "assessnumeracy"
    }


    function DoAssignment() {
        console.log(assignments);
        console.log(doingAssignment);
        updateDoingAssignment();
    }

    function EndAssignment() {
        updateDoingAssignment(null);

        axios({
            url: `${process.env.REACT_APP_OAUTH_URL}/api/homework`,
            method: "get",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${access_token}`
            }
        }).then((response) => {
            if (response.data !== undefined) {
                var i;
                var count = 0;
                console.log(response.data);
                var temphomeworks = [];
                response.data.forEach(element => {
                    var temphomework = element;
                    console.log(element);
                    if (element.custom_list != undefined) {
                        var customlist = JSON.parse(temphomework.custom_list).list;
                        console.log("NOT UNDEFINED");
                        console.log(customlist);
                        /*
                        var temptopics = [];     
                        //add topics 
                        customlist.forEach(question => {
                            let topic = {"topic_key":question.id,name}
                        });*/
                        temphomework.customlist = customlist;
                    }
                    temphomeworks.push(temphomework);
                });

                updateAssignments(temphomeworks);
                for (i = 0; i < response.data.length; i++) {
                    if (response.data[i].important == 1 && response.data[i].submissions.length == 0 && response.data[i].assessment_type != "clash") {
                        count++;
                    }
                }

                if (count > 0) {
                    props.update(true);
                    console.log("had important");
                    console.log(props.update);
                }
                else {
                    props.update(false);
                    console.log("no important");
                    console.log(props.update);
                }
            }
        });

        setRefresher(!refresher);
    }

    useEffect(() => {
        const getPupilAssignments = async () => {
            try {
                const response = await axios({
                    url: `${process.env.REACT_APP_OAUTH_URL}/api/homework`,
                    method: "get",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${access_token}`
                    }
                });

                if (response.data !== undefined) {
                    console.log(response.data);
                    var temphomeworks = [];
                    response.data.forEach(element => {
                        var temphomework = element;
                        if (new Date(temphomework.starts_at).toDateString() == new Date().toDateString()) {
                            console.log(element);
                            if (element.custom_list != undefined) {
                                var customlist = JSON.parse(temphomework.custom_list).list;
                                console.log("NOT UNDEFINED");
                                console.log(customlist);
                                /*
                                var temptopics = [];     
                                //add topics 
                                customlist.forEach(question => {
                                    let topic = {"topic_key":question.id,name}
                                });*/
                                temphomework.customlist = customlist;
                            }
                            temphomeworks.push(temphomework);
                        }
                    });

                    updateAssignments(temphomeworks);
                    //change the data
                    var i;
                    var count = 0;
                    var incompleteCounter = 0;
                    var clashCounter = 0;

                    for (i = 0; i < response.data.length; i++) {
                        if (response.data[i].assessment_type != "clash" && response.data[i].important == 1 && response.data[i].submissions.length == 0 && (response.data[i].highest_level_reached == null || response.data[i].highest_level_reached == 0)) {
                            count++;
                        }

                        if (response.data[i].assessment_type != "clash" && response.data[i].submissions.length == 0 && (response.data[i].highest_level_reached == null || response.data[i].highest_level_reached == 0)) {
                            incompleteCounter++;
                        }

                        if (response.data[i].assessment_type == "clash" && response.data[i].submissions.length == 0 && (response.data[i].highest_level_reached == null || response.data[i].highest_level_reached == 0)) {
                            clashCounter++;
                        }


                    }

                    if (count > 0) {
                        props.update(true, incompleteCounter);
                        console.log("had important");
                        console.log(props.update);
                    }
                    else {
                        props.update(false, incompleteCounter);
                        console.log("no important");
                        console.log(incompleteCounter);
                        console.log(props.update);
                        if (clashCounter > 0) {
                            props.clashupdate(true, clashCounter);
                        }
                    }
                }
            } catch (e) {
                throw new Error(e);
            }
        };

        getPupilAssignments();
    }, []);

    //clash methods
    useEffect(() => {
        const getClashData = async () => {
            try {
                const response = await axios({
                    url: `${process.env.REACT_APP_OAUTH_URL}/api/classclashscores`,
                    method: "get",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${access_token}`
                    }
                });

                if (response.data !== undefined) {
                    console.log(response.data);
                    response.data.forEach(element => {
                        console.log(element);
                    });
                    if (response.data.length > 0) {
                        setClashLeaderboard(response.data);
                    }
                }
            } catch (e) {
                throw new Error(e);
            }
        };

        getClashData();
    }, [refresher]);

    useEffect(() => {
        const getRecentClashBattle = async () => {
            try {
                const response = await axios({
                    url: `${process.env.REACT_APP_OAUTH_URL}/api/recentclashbattlescores`,
                    method: "get",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${access_token}`
                    }
                });

                if (response.data !== undefined && response.data != "") {
                    console.log(response.data);
                    var temphomeworks = [];
                    response.data.forEach(element => {
                        //console.log(element);
                    });
                    setClashRecent(response.data);
                }
            } catch (e) {
                throw new Error(e);
            }
        };

        getRecentClashBattle();
    }, [refresher]);

    function GetAssignmentsCount() {
        let count = 0;
        if (assignments == null)
            return 0;

        // console.log("ASSIGNMENTS", assignments);
        for (let i = 0; i < assignments.length; i++) {
            const element = assignments[i];
            //console.log(element);
            //console.log(element.submissions.length);
            if (element.assessment_type == "clash" && element.submissions.length == 0) {
                count++;
            }
        }

        return count;
    }

    function HasPupil(list, pid) {
        var hasp = false;
        list.forEach(element => {
            if (element.pupil_id == pid) {
                hasp = true;
            }
        });

        return hasp;
    }

    function ResultsExist(list, pid) {
        var exists = false;
        console.log("do I exist")
        console.log(pid);
        console.log(list);
        list.forEach(element => {
            if (element.pupil_id == pid) {
                exists = true;
            }
        });
        console.log(exists);
        return exists;
    }

    function GetPupil(list, pid) {
        var pupil = new Object();
        pupil.rank = "N/A";
        pupil.school_name = "N/A";
        pupil.total_correct = 0;
        pupil.points = 0;
        list.forEach(element => {
            if (element.pupil_id == pid) {
                pupil = element;
            }
        });
        return pupil;
    }

    function GetRank(list, pid) {
        var rank = 9999;

        list.forEach(element => {
            if (element.pupil_id == pid) {
                rank = element.rank;
            }
        });
        console.log("RANK: " + rank);
        return rank;
    }

    function PupilTable() {
        if (war.subs == undefined) {
            return (
                <h2>N/A</h2>
            );
        }

        if (war.subs.length == 0) {
            return (
                <h2>No Scores</h2>
            );
        }

        let recentdata = [];
        let allsubs = war.subs;



        allsubs.sort(function (a, b) {
            return b.total_correct - a.total_correct;
        });

        for (let i = 0; i < allsubs.length; i++) {
            allsubs[i].rank = i + 1;
        }

        let pupils = allsubs;

        console.log("PUPILS");
        console.log(pupils);

        return (
            <table style={{ fontSize: "15px" }}>
                <tr style={{ fontSize: "12px" }}>
                    <th>Pupil</th>
                    <th>{GetSchoolText("School")}</th>
                    <th>Correct Answers</th>
                    <th>Rank</th>
                </tr>
                {pupils.slice(0, 5).map(data => (
                    <tr style={{ color: CheckStyle(data) }}>
                        <th>{CheckName(data)}</th>
                        <th>{SchoolName(data)}</th>
                        <th>{data.total_correct}</th>
                        <th>{data.rank}</th>
                    </tr>
                ))}
                <tr></tr>
                {ResultsExist(pupils, state.pupil.pupil_id) == true && pupils.length > 0 && GetRank(pupils, state.pupil.pupil_id) > 5 ? (
                    <tr style={{ color: CheckStyle(GetPupil(pupils, state.pupil.pupil_id)) }}>
                        <th>You</th>
                        <th>{SchoolName(GetPupil(pupils, state.pupil.pupil_id))}</th>
                        <th>{GetPupil(pupils, state.pupil.pupil_id).total_correct}</th>
                        <th>{GetPupil(pupils, state.pupil.pupil_id).rank}</th>
                    </tr>
                ) : (
                    <tr></tr>
                )}
            </table>
        );
    }

    function TrustTable() {
        if (war.subs == undefined) {
            return (
                <h2>N/A</h2>
            );
        }

        let recentdata = [];
        let allsubs = war.subs;
        console.log(allsubs);

        let scores = [];
        let trusts = [];
        scores = WarScoresTrustData();
        trusts = scores;
        trusts.sort(function (a, b) {
            return b.total_correct - a.total_correct;
        });

        trusts.forEach(trust => {
            trust.average_percentage = Math.round(((100 * trust.total_correct) / trust.total_asked));
        });

        return (
            <table style={{ fontSize: "15px" }}>
                <tr style={{ fontSize: "12px" }}>
                    <th>Trust name</th>
                    <th>Average percentage</th>
                    <th>Total correct answers</th>
                    <th>Average rank per student</th>
                </tr>
                {trusts.slice(0, 5).map(lb => (
                    lb.total_asked > 0 ? (
                        <tr>
                            <th>{lb.name}</th>
                            <th>{lb.average_percentage}%</th>
                            <th>{lb.total_correct}</th>
                            <th>{lb.average_rank}</th>
                        </tr>
                    ) : (
                        <tr></tr>
                    )

                ))}
            </table>
        );
    }


    function GetWarTrust(name, warTrusts) {
        for (let i = 0; i < warTrusts.length; i++) {
            const trust = warTrusts[i];
            if (name == trust.name) {
                return i;
            }
        }
        return null;
    }

    function WarScoresTrustData() {
        let warTrusts = [];
        if (!war.subs) return [];
        for (let i = 0; i < war.subs.length; i++) {
            let score = war.subs[i];
            score.rank = i + 1;
            let trust = GetWarTrust(score.trust_name, warTrusts);
            if (trust == null) {
                warTrusts.push({
                    name: score.trust_name,
                    total_correct: score.total_correct,
                    total_asked: score.total_asked,
                    total_students: 1,
                    total_rank: score.rank,
                    average_rank: score.rank
                });
            } else {
                warTrusts[trust].total_correct += score.total_correct;
                warTrusts[trust].total_asked += score.total_asked;
                warTrusts[trust].total_students++;
                warTrusts[trust].total_rank += score.rank;
                warTrusts[trust].average_rank = (warTrusts[trust].total_rank / warTrusts[trust].total_students).toFixed(2);
            }
        }
        // Only return trusts with 5 or more pupils
        return warTrusts.filter(t => t.total_students >= 5);
    }

    function GetWarSchool(id, warSchools) {
        for (let i = 0; i < warSchools.length; i++) {
            const school = warSchools[i];
            if (id == school.school_id) {
                return i;
            }
        }
        return null;
    }

    function WarScoresSchoolData() {
        let warSchools = [];
        if (!war.subs) return [];
        for (let i = 0; i < war.subs.length; i++) {
            let score = war.subs[i];
            score.rank = i + 1;
            let school = GetWarSchool(score.school_id, warSchools);
            if (school == null) {
                warSchools.push({
                    school_id: score.school_id,
                    school_name: score.school_name,
                    total_correct: score.total_correct,
                    total_asked: score.total_asked,
                    total_students: 1,
                    total_rank: score.rank,
                    average_rank: score.rank
                });
            } else {
                warSchools[school].total_correct += score.total_correct;
                warSchools[school].total_asked += score.total_asked;
                warSchools[school].total_students++;
                warSchools[school].total_rank += score.rank;
                warSchools[school].average_rank = (warSchools[school].total_rank / warSchools[school].total_students).toFixed(2);
            }
        }
        // Only return schools with 5 or more pupils
        return warSchools.filter(s => s.total_students >= 5);
    }


    function WarScoresClassData() {
        let warSchools = [];
        if (!war.subs) return [];
        for (let i = 0; i < war.subs.length; i++) {
            let score = war.subs[i];
            score.rank = i + 1;
            let school = GetWarSchool(score.classroom_id, warSchools);
            if (school == null) {
                warSchools.push({
                    school_id: score.classroom_id,
                    school_name: score.classroom_name,
                    total_correct: score.total_correct,
                    total_asked: score.total_asked,
                    total_students: 1,
                    total_rank: score.rank,
                    average_rank: score.rank
                });
            } else {
                warSchools[school].total_correct += score.total_correct;
                warSchools[school].total_asked += score.total_asked;
                warSchools[school].total_students++;
                warSchools[school].total_rank += score.rank;
                warSchools[school].average_rank = (warSchools[school].total_rank / warSchools[school].total_students).toFixed(2);
            }
        }
        // Only return classes with 5 or more pupils
        return warSchools.filter(s => s.total_students >= 5);
    }





    function SchoolName(p) {
        console.log("getting school name");
        if (war.settings.mode.includes("class")) {
            return p.classroom_name;
        } else {
            return p.school_name;
        }
    }

    function SchoolTable() {
        if (war.subs == undefined) return <h2>N/A</h2>;

        let scores = war.settings.mode.includes("class") ? WarScoresClassData() : WarScoresSchoolData();

        scores.forEach(item => {
            item.average_percentage = Math.round(((100 * item.total_correct) / item.total_asked));
        });

        scores.sort((a, b) => a.average_rank - b.average_rank);

        return (
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <table style={{ fontSize: "15px" }}>
                    <thead>
                        <tr style={{ fontSize: "12px" }}>
                            <th>{GetSchoolText("School Name")}</th>
                            <th>Avg %</th>
                            <th>Total Correct</th>
                            <th>Avg Rank</th>
                        </tr>
                    </thead>
                    <tbody>
                        {scores.slice(0, 5).map((lb, i) => (
                            <tr key={i}>
                                <th>{lb.school_name}</th>
                                <th>{lb.average_percentage}%</th>
                                <th>{lb.total_correct}</th>
                                <th>{lb.average_rank}</th>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div style={{ marginTop: 'auto', padding: '10px' }}>
                    <p style={{ fontSize: '11px', margin: '5px 0', color: '#573474' }}>
                        Scores between 8pm and 6am are not taken into account.
                    </p>
                    <LinkButton
                        onClick={handleInfoOpen}
                        style={{
                            fontSize: '1.2em', // Smaller than the play button
                            padding: '0.2em 0.5em',
                            width: 'auto',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            margin: '0'
                        }}
                    >
                        <span style={{ fontSize: '1.5em' }}>ⓘ</span>
                    </LinkButton>
                </div>
            </div>
        );
    }

    function CheckStyle(pupil) {
        if (CheckName(pupil) == "YOU") {
            return "red";
        } else {
            return "#573474";
        }
    }

    function CheckName(pupil) {
        console.log("STATE", state);
        console.log(pupil);
        if (state.pupil != null) {
            if (pupil != null) {
                if (pupil.pupil_id == state.pupil.pupil_id) {
                    return "YOU";
                } else {
                    return pupil.pname;
                }
            }
        } else {
            if (pupil != null) {
                return pupil.pname;
            } else {
                return "";
            }

        }
    }

    function ReturnBackground() {
        if (war != undefined && war.settings != undefined) {
            if (war.settings.galaxy_id == 22) {
                return mCupBG;
            } else if (war.settings.galaxy_id == 38) {
                return sCupBG;
            } else if (war.settings.galaxy_id == 39) {
                return ks1CupBG;
            }
        } else {
            return sCupBG;
        }
        return CupBG;
    }

    function ReturnButton() {
        console.log(war);
        if (war != undefined && war.settings != undefined) {
            if (war.settings.galaxy_id == 22) {
                return (<LinkButton onClick={() => DoMTC()} >Play MTC</LinkButton>);
            } else if (war.settings.galaxy_id == 38) {
                return (<LinkButton onClick={() => DoSpellingSATs()} >Play Spelling Cup</LinkButton>);
            } else if (war.settings.galaxy_id == 39) {
                return (<LinkButton onClick={() => DoKS1()} >Play Key Stage 1 Arithmetic</LinkButton>);
            }
        } else {
            return (<div></div>);
        }

    }

    function GetSchoolText(input) {
        console.log(war);
        if (war.settings.mode.includes("class")) {
            return input.replace("School", "Classroom").replace("school", "classroom");
        }
        else {
            return input
        }
    }

    function WarDate() {
        let endDate = new Date(war.settings.ends_at);
        return endDate.getDate() + "/" + (endDate.getMonth() + 1) + "/" + endDate.getFullYear();
    }

    function UpcomingWarDate() {
        let startDate = new Date(war.upcomingWar.starts_at);
        return startDate.getDate() + "/" + (startDate.getMonth() + 1) + "/" + startDate.getFullYear();
    }

    const calculateTimeUntilWar = (startDate) => {
        if (!startDate) return "Time not available";

        const now = new Date();
        const warStart = new Date(startDate);
        const diffMs = warStart - now;

        if (diffMs <= 0) return "Event has started";

        // Calculate days by comparing dates
        const startOfDayNow = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const startOfDayWar = new Date(warStart.getFullYear(), warStart.getMonth(), warStart.getDate());
        const diffDays = Math.round((startOfDayWar - startOfDayNow) / (1000 * 60 * 60 * 24));

        // Calculate hours and minutes
        const hours = Math.floor(diffMs / (1000 * 60 * 60));
        const minutes = Math.floor(diffMs / (1000 * 60));

        if (diffDays >= 1) {
            return `${diffDays} day${diffDays !== 1 ? 's' : ''} until event`;
        } else if (hours >= 1) {
            return `${hours} hour${hours !== 1 ? 's' : ''} until event`;
        } else {
            return `${minutes} minute${minutes !== 1 ? 's' : ''} until event`;
        }
    };

    function CupMenu() {
        if (doingSPATS == true) {
            return (
                <SPATS
                    ratingmode={true}
                    eventscreen={true}
                />);
        } else if (doingKS1 == true) {
            return (
                <KS1
                    ratingmode={true}
                    eventscreen={true}
                />);
        } else {
            return (<CupContainer style={{ backgroundImage: `url(${ReturnBackground()})` }}>
                <Scale scaleTo={1720}>
                    {war.status == "OK" ? (
                        <div>
                            {war.settings && war.settings.mode == "trust" && (
                                <FlexBox style={{ justifyContent: "center" }}>
                                    <ClashFrame><h1>Trust Results:</h1>{TrustTable()}</ClashFrame>
                                </FlexBox>
                            )}
                            <FlexBox>
                                {war.settings != "" && war.settings != undefined ? (
                                    <FlexBox>
                                        <ClashFrame><h1>Student Results:</h1>{PupilTable()}</ClashFrame>

                                        <ClashFrame style={{ width: "350px" }}>
                                            <h1 style={{ textAlign: "center" }}>End Date:<br /> {WarDate()} </h1>
                                            {ReturnButton()}
                                        </ClashFrame>
                                        <ClashFrame><h1>{GetSchoolText("School Results:")}</h1>{SchoolTable()}</ClashFrame>
                                    </FlexBox>
                                ) : (
                                    <>
                                        {war.upcomingWar ? (
                                            <FlexBox style={{
                                                flexDirection: "column",
                                                alignItems: "center",
                                                gap: "20px",
                                                backgroundColor: "white",
                                                border: "2px solid purple",
                                                padding: "20px",
                                                borderRadius: "8px"
                                            }}>
                                                <h1 style={{ textAlign: "center" }}>Upcoming Competition</h1>
                                                <h1 style={{ textAlign: "center" }}>Starts: {UpcomingWarDate()}</h1>
                                                <h1 style={{ textAlign: "center" }}>{calculateTimeUntilWar(war.upcomingWar.starts_at)}</h1>
                                            </FlexBox>
                                        ) : (
                                            <h1 style={{ textAlign: "center" }}>No Cup available</h1>
                                        )}
                                    </>
                                )}
                            </FlexBox>
                        </div>

                    ) : (
                        <h1 style={{ textAlign: "center" }}>Fetching Cup... </h1>
                    )}
                    {infoOpen && (
                        <div style={{
                            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                            backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center',
                            alignItems: 'center', zIndex: 9999
                        }}>
                            <div style={{
                                backgroundColor: 'white',
                                padding: '50px',            // Increased padding
                                borderRadius: '20px',
                                maxWidth: '800px',          // Wider window
                                width: '90%',               // Responsive width
                                border: '6px solid #573474',
                                boxShadow: '0 0 40px rgba(0,0,0,0.6)',
                                position: 'relative',
                                textAlign: 'center'
                            }}>
                                <h1 style={{ color: '#573474', marginTop: 0, fontSize: '3.5em' }}>
                                    ⓘ How Rankings Work
                                </h1>

                                <div style={{ textAlign: 'left', margin: '30px 0' }}>
                                    <p style={{ fontSize: '28px', lineHeight: '1.6', color: '#333' }}>
                                        Rankings are based on the <strong>average rank</strong> of all students in your class or school.
                                    </p>
                                    <p style={{ fontSize: '28px', lineHeight: '1.6', color: '#333' }}>
                                        Each student's rank comes from the number of correct answers they give across all their Event games - so the more games someone plays, the higher their rank is likely to be.
                                    </p>
                                    <p style={{ fontSize: '30px', lineHeight: '1.6', fontWeight: 'bold', color: '#573474', backgroundColor: '#f4effa', padding: '15px', borderRadius: '10px' }}>
                                        Your class or school's position depends on everyone's average rank, not just the top players.
                                    </p>
                                </div>

                                <LinkButton
                                    onClick={handleInfoClose}
                                    style={{
                                        fontSize: '2.5em',
                                        padding: '0.5em 2em',
                                        width: 'auto',
                                        marginTop: '20px'
                                    }}
                                >
                                    Close
                                </LinkButton>
                            </div>
                        </div>
                    )}
                </Scale>
            </CupContainer>);
        }
    }

    return doingMTC == true ? (
        <MTCRating
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            mode={war?.settings?.mode?.includes("y3") ? "y3" : null}
        />
    ) : (
        <div style={{ height: "100%" }}>
            {CupMenu()}
        </div>
    );
}

export default Assignments;


const FlexBox = styled.div`
display: flex;

`

const ClashFrame = styled.div`
  width: 600px;
  height: 300px;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 10px;
  border-style: groove;
  display: relative;
  text-align: center;
  padding: 5px;
  margin: 20px;
`;

const StyledLink = styled(Link)`
  display: block;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  width: 100%;
  border: 2px solid #e88f12;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: 15px 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  text-decoration: none;
  text-align: center;

  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const CupContainer = styled.div`
    display: flex;
    flex-flow: column nowrap;
    padding-top: 40px;
    padding-bottom: 40px;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
    background-image: url(${CupBG});
    background-repeat: no-repeat;
    background-size: cover;
    box-sizing: border-box;
    overflow-y: auto;

    h1 {
        color: #673c8c;
        margin: 0;
        margin-bottom: 0.25em;
        font-size: 4em;
    }

    div:only-child{
        margin: auto 0;
    }

    div.top{
        margin-top: auto;
    }

    div.bottom{
        margin-bottom: auto;
    }
`;
